let data13;
if (typeof window === "undefined") {
  data13 = require("../static-s13/Data.json");
} else {
  data13 = window.data13;
}

export { data13 };
